import * as React from 'react'

function SvgZoomIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M22 2h-6v2h2.586l-3.293 3.293 1.414 1.414L20 5.414V8h2V2ZM2 2v6h2V5.414l3.293 3.293 1.414-1.414L5.414 4H8V2H2ZM2 22v-6h2v2.586l3.293-3.293 1.414 1.414L5.414 20H8v2H2ZM22 22v-6h-2v2.586l-3.293-3.293-1.414 1.414L18.586 20H16v2h6Z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgZoomIcon
